import React, {useEffect,useState} from 'react';
import Popup from "reactjs-popup";
import Slider, { Settings as CarouselSettings } from 'react-slick';
import './styles.scss';

const SingleImageSlider = (props:any) => {
  
  const [images, setImages] = useState([]);
  const [componentId, setComponentId] = useState([]);

  var auto_play = false;
  if (props.auto_advance_slides && props.auto_advance_slides == 1) {
    auto_play = true;
  }

  var autoplaySpeed = 4000;
  if (props.auto_advance_slides_speed) {
    autoplaySpeed = Number(props.auto_advance_slides_speed);
  }

  useEffect(() =>
  {
    if(props !== undefined)
    {
      if(props.slider_items)
      { 
        let newArray:any = []
        props.slider_items.map((data:any)=>
        {
          newArray.push(data)
        })
        setImages(newArray)
      }
    }
  },[])

  const settings: CarouselSettings = {
    autoplay: auto_play,
    autoplaySpeed: autoplaySpeed,
    slidesToShow: 1,
    slidesToScroll: 1,
    focusOnSelect: false,
    speed: 600,
    dots: true,
    className: 'item',
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
        },
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <section className="react-hero-slider" id={props.componentId}>
      <div className="models-slider cols-3 slick-initialized slick-slider slick-dotted" >
        <Slider {...settings}>
          {
            images.length > 0 ?
            images.map((data:any) => (
              <div id={data.componentId} className="slider-outer">
                <img src={data.image} alt={data.imageAlt} className="desktop-image" />
                <img src={data.mobile_image} alt={data.mobileImageAlt} className="mobile-image"/>
              </div>
            ))
            :
            null
          }
        </Slider>
      </div>
    </section>
  );
};

export default SingleImageSlider;
